'use strict';

import ServiceReportForm from "./utils/service-report-form";
import Modal from './utils/modal';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.pl.min';

(new ServiceReportForm());

$(document).ready(function () {
    $(".datepicker").datepicker("destroy");
    $(".datepicker").datepicker({
        startDate: new Date('01-01-1996'),
        endDate: new Date(),
        language: 'pl'
    });
});

const serviceReportRules = new Modal()
    .setTriggerSelector('.service-report-rules-modal-trigger')
    .setModalId('service-report-rules-modal')
    .setModalWrapperId('service-report-rules-modal-wrapper')
    .setUpListenersForm();
serviceReportRules.render();




// WEBPACK FOOTER //
// ./assets/js/service-report-create.js